import Checkout from "../Components/Checkout/Checkout"

const CheckoutPage = (props) => {
    return (
        <Checkout total = {props.total} setTotal = {props.setTotal}/>
    );
};

export default CheckoutPage;